import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { TaActionTypes, TaActions } from "../../../actionTypes/master/taActionTypes";

import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { createTaApi, editTaDataByIdApi, getTaDataByIdApi, getTaListApi } from "../../requests/master/taRequests";
import { getTaList, setTaDataById, setTaList, setTaListPageCount } from "../../../actions/master/taActions";


function* createTaHandler(action: TaActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createTaApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getTaListHandler(action: TaActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getTaListApi, action.payload);

    if (data.status) {
      const fallBackData = [
        {
          id: 0,
          ta_name: "-",
          ta_code: "-",
          contact_number: "-",
          email: "-",
          profile_status: "-",
          created_by: 0,
        },
      ];
      yield put(setTaList(data?.data?.rows || fallBackData));
      yield put(setTaListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getTaDataByIdHandler(action: TaActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getTaDataByIdApi, action.payload);
    if (data.status) {
      yield put(setTaDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editTaDataByIdHandler(action: TaActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editTaDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getTaList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// vendor sagas
export default function* taSaga() {
  yield takeLatest(TaActions.CREATE_TA, createTaHandler);
  yield takeLatest(TaActions.GET_TA_LIST, getTaListHandler);
  yield takeLatest(TaActions.GET_TA_DATA_BY_ID, getTaDataByIdHandler);
  yield takeLatest(TaActions.EDIT_TA_DATA_BY_ID, editTaDataByIdHandler);
}
